import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import PanelTemplate from '../../common/PanelTemplate';
import { get, isEmpty } from '../../../utils/lodash';
import I18n from '../../../config/locales';
import SupportElement from '../SupportElement';
import GridProfileToken from '../GridProfileToken';
import { getSupportList, getDistributorList } from '../helper';
import feature from '../../../utils/feature';

const useStyles = makeStyles(theme => ({
  supportWrapper: {
    padding: theme.spacing(2, 2, 1, 2),
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
    gridColumnGap: theme.spacing(3),
    gridRowGap: theme.spacing(1.5)
  },
  gridToken: {
    borderTop: '1px solid #e0e0e0',
    padding: theme.spacing(2, 2, 1)
  },
  gridTokenText: {
    color: theme.palette.tertiary.main,
    fontSize: 13,
    display: 'inline-block',
    cursor: 'pointer'
  }
}));

const adminRoles = [ 'admin', 'support_tech', 'support_read' ];

const Support = props => {
  const {
    accountData,
    belongsToIn,
    belongsToMx,
    belongsToIt,
    belongsToFr,
    belongsToUs,
    countryCode,
    belongsToPa,
    belongsToCo,
    belongsToCr,
    belongsToBr,
    belongsToPr,
    belongsToAw,
    belongsToDe,
    companyId,
    viewOnlyAccess,
    featureList
  } = props;
  const classes = useStyles();
  const roles = get(accountData, 'roles', []) || [];
  const isAdmin = !!adminRoles.find(role => roles.includes(role)) && companyId.toString() === '5';
  const eligibleCountry =
    belongsToMx || belongsToPa || belongsToCo || belongsToCr || belongsToBr || belongsToAw || belongsToPr;
  const [ list, setList ] = useState([]);
  const [ showGridToken, setShowGridToken ] = useState(false);
  const isCommercialPageEnabled =
    !isEmpty(featureList) && feature.isFeatureEnabled('COMMERCIAL_SHORTCUT_PAGE') && belongsToUs;
  const isLeadsPageEnabled =
    !isEmpty(featureList) && feature.isFeatureEnabled('LEADS_QUICKACCESS') && belongsToUs;

  useEffect(
    () => {
      const listToGet = accountData.is_distributor
        ? getDistributorList(
            belongsToIn,
            belongsToMx,
            belongsToBr,
            belongsToIt,
            belongsToFr,
            belongsToUs
          )
        : getSupportList(
            belongsToIn,
            belongsToMx,
            belongsToBr,
            belongsToIt,
            belongsToFr,
            belongsToUs,
            belongsToDe
          );
      const supportLinks =  listToGet.filter(support => support && support.name);
      setList(supportLinks);
    },
    [ belongsToFr, belongsToIn, belongsToIt, belongsToMx, belongsToBr, belongsToUs, belongsToDe, countryCode ]
  );

  return (
    <PanelTemplate header={I18n.t('dashboard.quickAccess')} boxShadow id="quickAccessBox">
      <Box className={classes.supportWrapper}>
        {list.map((support, index) => {
          // Token is expired so moving to static url // if (support.type === 'community') support.url = get(accountData, 'enphase_community_url', support.url);
          return (support.type === 'commercial' && !isCommercialPageEnabled ) || (support.type === 'leads' && !isLeadsPageEnabled ) ? null : (
            <SupportElement key={index} data={support} />
          );
        })}
      </Box>
      {(isAdmin || eligibleCountry) && !viewOnlyAccess ? (
        <Typography className={classes.gridToken} component="div">
          <Typography className={classes.gridTokenText} component="div" onClick={() => setShowGridToken(true)}>
            {I18n.t('dashboard.gridProfileToken')}
          </Typography>
          {showGridToken && <GridProfileToken handlePopupClose={() => setShowGridToken(false)} />}
        </Typography>
      ) : null}
    </PanelTemplate>
  );
};
const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => ({
  belongsToIn: state.appReducer.belongsToIn,
  belongsToMx: state.appReducer.belongsToMx,
  belongsToIt: state.appReducer.belongsToIt,
  belongsToFr: state.appReducer.belongsToFr,
  belongsToUs: state.appReducer.belongsToUs,
  belongsToPa: state.appReducer.belongsToPa,
  belongsToCo: state.appReducer.belongsToCo,
  belongsToCr: state.appReducer.belongsToCr,
  belongsToBr: state.appReducer.belongsToBr,
  belongsToPr: state.appReducer.belongsToPr,
  belongsToAw: state.appReducer.belongsToAw,
  belongsToDe: state.appReducer.belongsToDe,
  countryCode: state.appReducer.countryCode,
  companyId: state.appReducer.companyId,
  viewOnlyAccess: state.accountReducer.viewOnlyAccess,
  featureList: state.appReducer.featureList
});

export default connect(mapStateToProps, mapDispatchToProps)(Support);
